import { error } from "@jutro/logger";

const WIDGET_ROOT_ID = "chat-wizard-root";
const WIDGET_DIV_ID = "a360GoogleChatBot";

const initChatWizard = ({
    proxyURL,
    jwtToken,
    frmsRegion = "PROD",
    getChatToken
}) => {
    if (typeof window.renderChatWidget !== "function") {
        error("Chat widget script not loaded");

        return
    }

    const root = document.getElementById(WIDGET_ROOT_ID);

    if (!root) {
        error(`${WIDGET_ROOT_ID} not found`);

        return
    }

    const getEISToken = async (identifier) => {
        console.log("IDENTIFIER RECEIVED FROM QUANTIFY");
        
        const EISToken = await getChatToken(identifier);
        
        console.log("EIS TOKEN RECEIVED FROM PC");

        return { token: EISToken };
        
    };

    window.getEISToken = getEISToken;


    if (proxyURL) {
        root.innerHTML = "";

        const div = document.createElement("div");

        div.id = WIDGET_DIV_ID;
        div.setAttribute("class", "ccaas-chat-widget-container ccass_chatBot_div");
        
        if(proxyURL.includes("http")){
            div.setAttribute("data-auth-url", proxyURL);
        }else{
            div.setAttribute("data-auth-url", "getEISToken");
        }
        
        
        if(frmsRegion === "MA11"){
            div.setAttribute("data-env","DEV")
        }else if (frmsRegion === "RA11"){
            div.setAttribute("data-env","QA")
        }else{
            div.setAttribute("data-env","PROD")
        }
        
        root.appendChild(div);

        window.renderChatWidget(WIDGET_DIV_ID, jwtToken);
    }
}

const destroyChatWizard = () => {
    const root = document.getElementById(WIDGET_ROOT_ID);

    if (root) {
        root.innerHTML = "";
    }
}

export default {
    initChatWizard,
    destroyChatWizard
}